// src/styles/colors_global.js
const colors = {
    red: "#d8314b",            // Couleur Rouge
    lightRed: "#e57a86",       // CouleurRouge claire      
    green: "#016666",          // Couleur verte
    lightGreen: "#bed1d0",     // Couleur verte claire
    orange: "#ffad65",         // Couleur orange
    white: "#FFFFFF",          // Blanc
    black: "#000000",          // Noir
    lightGray: "#D7E1DE",      // Gris clair
    bleu: "#d2e3ff", // belu clair
    vert_moyen: "#38c075", // vert moyen
    vert_fonce: "#0e5757", // vert fonce
    vert_soft: "#0e9488", //
    vert_gris: "#c8d7d6",
    vert_fonce: "#9fb5b3",
    vert_sombre: "#7a9896", 
    vert_profond: "#5d7c79",
    vert_intense: "#4a6663"
};

export default colors;